// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"506f3c9e","592":"0f1fe67e"}[chunkId] + ".chunk.js";
};